<template>
  <section>
    <ScrollAppHeader v-bind:attach-home="attachHome"></ScrollAppHeader>
    <div class="bs-b">
      <AppHeader v-bind:attach-home="attachHome" v-if="!hideAppHeader"></AppHeader>
    
      <div class="sub-header">
        <slot name="sub-header"></slot>
      </div>
    </div>

    <div class="action-bar">
      <slot name="action-bar"></slot>
    </div>

    <div class="layout-body" :style="bodyStyle">
      <LoadingBounce v-if="false"></LoadingBounce>
      <slot name="layout-body"></slot>
    </div>

    <div class="modal-area">
      <slot name="modal-area"></slot>
    </div>

    <div class="floating-action-menu">
      <slot name="floating-action-menu"></slot>
    </div>

    <WelcomeMessageModal></WelcomeMessageModal>

    <CardPreview
      v-on:show-report-content-modal="reportContentModalIsShown = true"
    />

    <!-- editor alert modals -->
    <b-modal id="file-size-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('common.modal.file_size_alert.message')"></div>
    </b-modal>

    <b-modal id="audio-size-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('common.modal.audio_size_alert.message')"></div>
    </b-modal>

    <b-modal id="file-type-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('common.modal.file_type_alert.message')"></div>
    </b-modal>

    <b-modal id="audio-type-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('common.modal.audio_type_alert.message')"></div>
    </b-modal>

    <b-modal id="file-reader-unsupported-alert"
             class="basic-modal no-header-modal hide-cancel-btn"
             :hide-header="true"
             :ok-title="$t('common.confirm')">
      <div v-html="$t('common.modal.file_reader_unsupported.message')"/>
    </b-modal>

    <b-modal id="max-image-limit-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('page_editor.alerts.max_image_limit')"></div>
    </b-modal>

    <b-modal id="max-audio-limit-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('page_editor.alerts.max_audio_limit')"></div>
    </b-modal>

    <b-modal id="max-video-limit-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('page_editor.alerts.max_video_limit')"></div>
    </b-modal>

    <b-modal id="only-audio-or-video-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('page_editor.alerts.only_audio_or_video')"></div>
    </b-modal>

    <b-modal id="unsupported-video-service-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('page_editor.alerts.unsupported_video_service')"></div>
    </b-modal>

    <b-modal id="video-load-failed-alert"
              class="basic-modal no-header-modal hide-cancel-btn"
              v-bind:hide-header="true"
              v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('page_editor.alerts.video_load_failed')"></div>
    </b-modal>

    <ReportContentFromPreview
      v-on:ok="onContentReportSent()"
      v-on:cancel="reportContentModalIsShown = false"
      v-if="reportContentModalIsShown"
    />

    <AiScoreGuideModal/>

    <CustomModal id="content-report-success-modal"
                 class="basic-modal no-header-modal hide-cancel-btn"
                 v-bind:hide-header="true"
                 v-bind:ok-title="$t('common.confirm')"
                 v-on:ok="contentReportSuccessModalIsShown = false"
                 v-if="contentReportSuccessModalIsShown">
      <div v-html="$t('common.modal.content_report_success.message')"></div>
    </CustomModal>

    <CustomModal id="is-empty-country-code"
                 class="basic-modal no-header-modal hide-cancel-btn"
                 v-bind:hide-header="true"
                 v-bind:ok-title="$t('common.confirm')"
                 v-on:ok="countryCodeSettingModalIsShown = false"
                 v-if="countryCodeSettingModalIsShown">
      <div>
        <div v-html="$t('common.empty_country_code.text')" />
        <a :href="countryCodeSettingLink" class="country-code-setting-link">{{ $t('common.empty_country_code.link') }} &gt;</a>
      </div>
    </CustomModal>

    <!-- basic error alert modal -->
    <b-modal id="basic-error-alert"
             class="basic-modal no-header-modal hide-cancel-btn"
             v-bind:hide-header="true"
             v-bind:ok-title="$t('common.confirm')">
      <div v-html="$t('common.modal.basic_error_alert.message')"></div>
    </b-modal>

    <div class="footer-area">
      <slot name="footer"></slot>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { isEmpty } from 'lodash';
  import { CLASSTING_URL } from '@/config';

  export default {
    name: 'main-layout',

    props: {
      attachHome: {
        type: Boolean,
        default: false,
      },
      hideAppHeader: {
        type: Boolean,
        default: false,
      },
      reportContentModalIsShownProp: {
        type: Boolean,
        default: false,
      },
      bodyStyle: {
        type: Object,
        default: Object,
      },
    },

    data() {
      return {
        contentReportSuccessModalIsShown: false,
        reportContentModalIsShown: false,
        countryCodeSettingModalIsShown: false,
      };
    },

    computed: {
      ...mapGetters([
        'currentUserContryCode',
      ]),

      countryCodeSettingLink() {
        return `${CLASSTING_URL}/settings/personal_info`;
      },
    },

    beforeMount() {
      if (isEmpty(this.currentUserContryCode) && this.$route.meta.requiresAuth) {
        this.countryCodeSettingModalIsShown = true;
      }
    },

    watch: {
      reportContentModalIsShownProp(value) {
        if (value) {
          this.reportContentModalIsShown = true;
        }
      },
      reportContentModalIsShown(value) {
        if (!value) {
          this.$emit('close-report-content-modal');
        }
      },
    },

    methods: {
      onContentReportSent() {
        this.reportContentModalIsShown = false;
        this.contentReportSuccessModalIsShown = true;
      },
    },
  };
</script>

<style lang="scss">
  .sub-header {
    background-color: #ffffff;

    .container {
      height: 60px;
    }

    .sub-header-header {
      margin-top: 40px;
      font-weight: bold;
    }

    .mnv-dropdown {
      @media (min-width: 576px) {
        margin-left: -10px;
      }
    }

    .sub-header-btn-row {
      text-align: center;
      padding: 12px;
    }

    .navbar {
      padding: 0;
      margin: 12px 0;
    }

    .navbar-nav {
      border: solid 1px #dddddd;
      flex-direction: row;
      border-radius: 4px;
      height: 36px;
      margin: 0 auto;
    }

    .navbar-nav>.nav-item .nav-link {
      min-width: 140px;
      text-align: center;
    }

    .navbar-nav>.nav-item.active {
      background-color: #00c896;
      margin: 2px;
      font-weight: bold;
      border-radius: 4px;
    }

    .navbar-nav>.nav-item:not(:first-child) {
    }

    .navbar-nav>.nav-item.active .nav-link {
      color: #ffffff; 
      font-weight: bold;
    }
  }

  .action-bar {
    border-bottom: 1px solid #d9d9d9;

    .container {
      height: 120px;
    }

    .action-subheader {
      position: absolute;
      top: 28px;
    }

    .action-header {
      margin-top: 40px;
      font-weight: bold;
    }

    .action-subheader+.action-header {
      margin-top: 50px;
    }

    .action-btn-row {
      margin-top: 44px;
    }
  }

  .layout-body {
    padding-top: 3px;

    &>.loading-bounce {
      margin-top: 110px;
    }

    hr {
      margin-top: 3px;
      margin-bottom: 12px;
    }
  }

  .country-code-setting-link {
    margin-top: 14px;
    color: #00c896;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/MainLayout.vue